// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// Import Bulma CSS
import 'bulma/css/bulma.min.css'
// Import custom styles
import './application.css'

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Bulma navbar burger toggle
document.addEventListener('DOMContentLoaded', () => {
  // // Get all "navbar-burger" elements
  // const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // // Add a click event on each of them
  // $navbarBurgers.forEach( el => {
  //   el.addEventListener('click', () => {
  //     // Get the target from the "data-target" attribute
  //     const target = el.dataset.target;
  //     const $target = document.getElementById(target);

  //     // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
  //     el.classList.toggle('is-active');
  //     $target.classList.toggle('is-active');
  //   });
  // });

  // Product category tabs
  const tabs = document.querySelectorAll('.tabs a');
  const categorySections = document.querySelectorAll('.category-section');

  tabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      // Remove active class from all tabs
      tabs.forEach(t => t.parentElement.classList.remove('is-active'));

      // Add active class to clicked tab
      tab.parentElement.classList.add('is-active');

      const targetCategory = tab.getAttribute('href').substring(1);

      // Show all categories if "all" is selected
      if (targetCategory === 'all') {
        categorySections.forEach(section => {
          section.style.display = 'block';
        });
      } else {
        // Hide all category sections
        categorySections.forEach(section => {
          section.style.display = 'none';
        });

        // Show the selected category section
        const targetSection = document.getElementById(targetCategory);
        if (targetSection) {
          targetSection.style.display = 'block';
        }
      }
    });
  });
});

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
